<template>
  <div class="comment" :class="{ incoming: !!authorType }">
    <div class="time">
      <span>
        {{ !!authorType ? "Пользователь" : getOrganizationName }}
      </span>
      <span>
        {{ parseDate(createdAt) }}
      </span>
    </div>

    <div class="text">{{ message }}</div>

    <div class="attachments" v-if="attachments.length">
      <i class="el-icon-paperclip"></i>
      <el-link
        v-for="file in attachments"
        :key="file.id"
        :href="file.url"
        type="primary"
        download
        target="_blank"
        class="link"
      >
        {{ file.fileName }}
      </el-link>
    </div>
  </div>
</template>
<script>
import { parseDate } from "@/plugins/dateParser";
import { mapGetters } from "vuex";

export default {
  props: ["message", "attachments", "authorType", "createdAt"],
  computed: {
    ...mapGetters(["getOrganizationName"])
  },
  methods: {
    parseDate(d) {
      return parseDate(d);
    }
  }
};
</script>
<style scoped>
.comment {
  padding: 0.5em;
  border: 1px solid #409eff;
  border-radius: 1em;
  border-bottom-right-radius: 0;
  align-self: end;
}

.incoming {
  border: 1px solid #e6a23c;
  border-radius: 1em;
  border-bottom-left-radius: 0;
  align-self: start;
}

.time {
  display: flex;
  justify-content: space-between;
  gap: 1em;
  font-size: x-small;
  color: #000000a2;
}

.text {
  margin-top: .5em;
  word-break: break-word;
}

.link {
  margin-top: 1em;
  display: inline;
  margin-right: 1em;
}
.attachments {
  margin-top: 1em;
}
</style>
